import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { required, email, numeric, minLength, helpers } from "vuelidate/lib/validators";
import { emailErrorMessagesMixin, lettersAndNumbersMixin, onlyNumbersMixin, onlyLettersMixin } from "~/mixins";
import { onlyLetters, onlyEmail, noSpecialChars } from "~/validators";
import { ConflictError, BadRequestError } from "~/abstractions/errors";

export default {
  mixins: [emailErrorMessagesMixin, lettersAndNumbersMixin, onlyNumbersMixin, onlyLettersMixin],
  data: function data() {
    var _$store$state$master = this.$store.state["master-data"],
        documentTypesCollaboratorsPage = _$store$state$master.documentTypesCollaboratorsPage,
        userCategories = _$store$state$master.userCategories;

    return {
      documentTypesCollaboratorsPage: documentTypesCollaboratorsPage,
      userCategories: userCategories,
      dialog: false,
      switchState: true,
      checkbox: false,
      sending: false,
      sellerName: "",
      sellerLastName: "",
      docNumber: "",
      docType: 1,
      email: "",
      multipleOptions: false,
      modalTitle: "",
      word: "",
      maxLengthDocumentNumber: 8,
      idUser: null,
      editState: false,
      actionButton: "",
      value: null,
      buttonName: "Crear",
      message: "",
      validBossEmail: false,
      conditionalIsSupervisor: "",
      conditionalShowMessageStatus: false,
      conditionalShowMessageSupervisor: false,
      messageStatus: "",
      messageDocumentNumber: "",
      resultValidEmailService: false,
      resultValidDocumentService: false,
      timeout: null,
      teamIsActive: true,
      isTeamActiveConditional: false,
      cellphone: null,
      userCategory: null,
      channel: null,
      subChannel: null,
      groupChannel: null,
      channels: [],
      subChannels: [],
      groupChannels: [],
      loadingSubChannels: false,
      loadingGroupChannels: false,
      username: null,
      password: null
    };
  },
  validations: function validations() {
    return {
      sellerName: {
        required: required,
        onlyLetters: onlyLetters("sellerName")
      },
      sellerLastName: {
        required: required,
        onlyLetters: onlyLetters("sellerLastName")
      },
      docType: { required: required },
      docNumber: {
        required: required,
        numeric: numeric,
        minLength: minLength(this.maxLengthDocumentNumber)
      },
      email: {
        required: required,
        // email,
        noSpecialChars: noSpecialChars("noSpecialChars"),
        emailValidate: onlyEmail("emailValidate")
      },
      cellphone: { required: required },
      userCategory: { required: required },
      channel: { required: required },
      subChannel: { required: required },
      groupChannel: { required: required }
    };
  },

  methods: _extends({}, mapActions({
    consultSubChannel: "affiliations/form/consultSubChannel",
    consultGroupChannel: "affiliations/form/consultGroupChannel"
  }), {
    addNewBossModal: function addNewBossModal() {
      this.dialog = true;
      this.modalTitle = "Nuevo Jefe";
      this.word = "create";
      this.actionButton = "Crear";
      this.editState = true;
      this.conditionalIsSupervisor = true;
      this.switchState = true, this.messageStatus = ' "Si desactiva al usuario no podrá acceder al sistema y esto afectará las dependencias asociadas" ';
    },
    editBossModal: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.dialog = true;
                this.modalTitle = "Editar Jefe";
                this.word = "edit";
                this.actionButton = "Guardar";
                this.buttonName = "Guardar";
                this.editState = true;
                this.conditionalIsSupervisor = false;

                _context.next = 9;
                return this.$store.dispatch("boss/findBossById", this.idUser);

              case 9:
                response = _context.sent;

                this.sellerName = response.firstname;
                this.sellerLastName = response.lastname;
                this.docType = response.idDocumentType;
                this.docNumber = response.documentNumber;
                this.email = response.email;
                this.switchState = response.isActive;
                this.cellphone = response.cellphone;
                this.channel = response.channelCode ? { value: response.channelCode, text: response.channelName } : null;
                this.subChannel = response.subChannelCode ? { value: response.subChannelCode, text: response.subChannelName } : null;
                this.groupChannel = response.groupChannelCode ? { value: response.groupChannelCode, text: response.groupChannelName } : null;
                this.userCategory = response.idUserCategory;
                this.username = response.username;
                this.password = response.password;

                this.resultValidDocumentService = true;
                this.resultValidEmailService = true;

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editBossModal() {
        return _ref.apply(this, arguments);
      }

      return editBossModal;
    }(),
    addNewSeller: function addNewSeller() {
      this.dialog = true;
      this.modalTitle = "Nuevo Vendedor";
      this.editState = true;
      this.actionButton = "Crear";
      this.messageStatus = ' "Si desactiva al usuario no podrá acceder al sistema" ';
      if (this.$isBoss() || this.$isAdmin() || this.$isAdminCollaborator()) {
        this.multipleOptions = true;
      }

      if (this.teamIsActive == true) {
        this.switchState = true;
        if (this.conditionalIsSupervisor == true) {
          this.switchState = true;
          this.checkbox = true;
        } else {
          this.checkbox = false;
          this.switchState = true;
        }
      } else {
        this.switchState = false;
        this.conditionalShowMessageStatus = false;
        this.isTeamActiveConditional = true;
        if (this.conditionalIsSupervisor == true) {
          this.switchState = false;
          this.checkbox = true;
        }
      }
    },
    editSeller: function editSeller() {
      this.dialog = true;
      this.modalTitle = "Editar Vendedor";
      this.editState = true;
      this.actionButton = "Guardar";
      this.buttonName = "Guardar";
    },
    onSubmit: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var timestamp, _ref3, existeCorreo, responseServer, _email, serverIp, conditionalIdTeam, conditional, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // servicio para verificar correo
                timestamp = Date.now();
                _context2.next = 4;
                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                  transaccionId: timestamp,
                  correo: this.email.toLowerCase()
                });

              case 4:
                _ref3 = _context2.sent;
                existeCorreo = _ref3.existeCorreo;
                responseServer = _ref3.responseServer;
                _email = _ref3.email;
                serverIp = _ref3.serverIp;

                if (!(responseServer === "Error")) {
                  _context2.next = 14;
                  break;
                }

                this.$swal("Error", "Error en el servicio. Vuelva a intentarlo mas tarde.", "error");
                this.sending = false;
                _context2.next = 57;
                break;

              case 14:
                if (!existeCorreo) {
                  _context2.next = 55;
                  break;
                }

                this.$v.$touch();
                this.sending = true;
                _context2.prev = 17;

                if (!(this.$isBoss() || this.modalTitle === "Nuevo Vendedor")) {
                  _context2.next = 30;
                  break;
                }

                conditionalIdTeam = this.$isBoss() === true ? this.value : this.idUser;
                conditional = this.checkbox === true ? 3 : 4;
                _context2.next = 23;
                return this.$store.dispatch("team/createdNewSeller", {
                  idTeam: conditionalIdTeam,
                  idDocumentType: Number(this.docType),
                  firstName: this.sellerName,
                  lastName: this.sellerLastName,
                  documentNumber: this.docNumber,
                  email: this.email,
                  username: "",
                  password: "",
                  isActive: this.switchState,
                  isSupervisor: this.checkbox,
                  idRole: conditional,
                  cellphone: this.cellphone,
                  channelCode: this.channel && this.channel.value,
                  channelName: this.channel && this.channel.text,
                  subChannelCode: this.subChannel && this.subChannel.value,
                  subChannelName: this.subChannel && this.subChannel.text,
                  groupChannelCode: this.groupChannel && this.groupChannel.value,
                  groupChannelName: this.groupChannel && this.groupChannel.text,
                  idUserCategory: this.userCategory
                });

              case 23:

                this.$emit("updateShowChannels", this.idUser);
                this.$store.commit("channel/updateSetListOfTeamForAdmin", conditionalIdTeam);
                if (this.$isSupervisor() == true) {
                  this.$emit("upDateListBoss");
                } else if (this.$isBoss() == true) {
                  this.$emit("notShowContent");
                  this.$emit("upDateTeam", this.value);
                }
                this.cancel();
                this.$emit("completeForm");
                _context2.next = 44;
                break;

              case 30:
                if (!(this.word == "create")) {
                  _context2.next = 39;
                  break;
                }

                _context2.next = 33;
                return this.$store.dispatch("boss/createdNewBoss", {
                  idDocumentType: Number(this.docType),
                  firstName: this.sellerName,
                  lastName: this.sellerLastName,
                  documentNumber: this.docNumber,
                  email: this.email,
                  username: "",
                  password: "",
                  isActive: this.switchState,
                  cellphone: this.cellphone,
                  channelCode: this.channel && this.channel.value,
                  channelName: this.channel && this.channel.text,
                  subChannelCode: this.subChannel && this.subChannel.value,
                  subChannelName: this.subChannel && this.subChannel.text,
                  groupChannelCode: this.groupChannel && this.groupChannel.value,
                  groupChannelName: this.groupChannel && this.groupChannel.text,
                  idUserCategory: this.userCategory
                });

              case 33:
                response = _context2.sent;

                this.$emit("completeForm");
                this.$emit("upDateListBoss");
                this.cancel();
                _context2.next = 44;
                break;

              case 39:
                _context2.next = 41;
                return this.$store.dispatch("boss/editBoss", {
                  idUser: this.idUser,
                  idDocumentType: Number(this.docType),
                  firstName: this.sellerName,
                  lastName: this.sellerLastName,
                  documentNumber: this.docNumber,
                  email: this.email,
                  username: this.username,
                  password: this.password,
                  isActive: this.switchState,
                  cellphone: this.cellphone,
                  channelCode: this.channel && this.channel.value,
                  channelName: this.channel && this.channel.text,
                  subChannelCode: this.subChannel && this.subChannel.value,
                  subChannelName: this.subChannel && this.subChannel.text,
                  groupChannelCode: this.groupChannel && this.groupChannel.value,
                  groupChannelName: this.groupChannel && this.groupChannel.text,
                  idUserCategory: this.userCategory
                });

              case 41:
                this.$emit("completeForm");
                this.$emit("upDateListBoss");
                this.cancel();

              case 44:
                this.dialog = false;
                _context2.next = 51;
                break;

              case 47:
                _context2.prev = 47;
                _context2.t0 = _context2["catch"](17);

                if (this.$isSupervisor()) {
                  this.idUser = this.$store.state.user.idTeam;
                }

                if (_context2.t0 instanceof ConflictError) {
                  if (this.modalTitle === "Nuevo Jefe" || this.modalTitle === "Nuevo Vendedor") {
                    this.$swal("No se pudo crear", _context2.t0.message, "warning");
                    this.modalTitle === "Nuevo Vendedor" ? this.addNewSeller() : "";
                  } else {
                    this.$swal("No se pudieron guardar tus cambios", _context2.t0.message, "warning");
                  }
                } else if (_context2.t0 instanceof BadRequestError) {
                  this.$swal("Error", _JSON$stringify(_context2.t0.data.constraints[0].constraints.isEmail), "warning");
                } else {
                  this.$controlMessage(_context2.t0);
                }

              case 51:
                this.sending = false;
                this.cancel();
                _context2.next = 57;
                break;

              case 55:
                this.$swal("Aviso", "No existe el correo " + this.email + ", ingresar uno correcto.", "warning");
                this.sending = false;

              case 57:
                _context2.next = 63;
                break;

              case 59:
                _context2.prev = 59;
                _context2.t1 = _context2["catch"](0);

                this.$swal("Aviso", "El correo ingresado tiene formato incorrecto.", "warning");
                this.sending = false;

              case 63:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 59], [17, 47]]);
      }));

      function onSubmit() {
        return _ref2.apply(this, arguments);
      }

      return onSubmit;
    }(),
    cancel: function cancel() {
      this.dialog = false;
      this.sellerName = "";
      this.sellerLastName = "";
      this.docNumber = "";
      this.email = "";
      this.docType = 1;
      this.checkbox = false;
      this.switchState = false;
      this.cellphone = null;
      this.channel = null;
      this.subChannel = null;
      this.groupChannel = null;
      this.userCategory = null;
      this.$v.$reset();
    },
    changeEvent: function changeEvent(val) {
      // console.log('change')
      switch (val) {
        case 1:
          this.maxLengthDocumentNumber = 8, this.validationDocument = val;
          this.docNumber = "";
          break;
        case 2:
          this.maxLengthDocumentNumber = 12, this.validationDocument = val;
          this.docNumber = "";
          break;
        case 4:
          this.maxLengthDocumentNumber = 12, this.validationDocument = val;
          this.docNumber = "";
          break;
        default:
          this.maxLengthDocumentNumber = 8;
          break;
      }
    },
    validateEmail: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                clearTimeout(this.timeout);

                if (!(this.email === "")) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", true);

              case 3:
                this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var conditional;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;

                          if (!(_this.modalTitle == "Nuevo Jefe" || _this.modalTitle == "Editar Jefe")) {
                            _context3.next = 7;
                            break;
                          }

                          conditional = _this.modalTitle == "Nuevo Jefe" ? 0 : _this.idUser;
                          _context3.next = 5;
                          return _this.$store.dispatch("boss/validationBossEmail", {
                            idUser: conditional,
                            email: _this.email
                          });

                        case 5:
                          _context3.next = 10;
                          break;

                        case 7:
                          if (!(_this.modalTitle == "Nuevo Vendedor" || _this.modalTitle == "Editar Vendedor")) {
                            _context3.next = 10;
                            break;
                          }

                          _context3.next = 10;
                          return _this.$store.dispatch("team/validSellersEmail", {
                            idUser: 0,
                            email: _this.email
                          });

                        case 10:
                          _this.resultValidEmailService = true;
                          _context3.next = 17;
                          break;

                        case 13:
                          _context3.prev = 13;
                          _context3.t0 = _context3["catch"](0);

                          if (_context3.t0 instanceof ConflictError) {
                            _this.message = _context3.t0.message;
                          } else {
                            _this.message = _JSON$stringify(_context3.t0.data.constraints[0].constraints.isEmail);
                          }
                          _this.resultValidEmailService = false;

                        case 17:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this, [[0, 13]]);
                })), 500);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateEmail() {
        return _ref4.apply(this, arguments);
      }

      return validateEmail;
    }(),
    validateDocNumber: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.docNumber === "")) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", true);

              case 2:
                clearTimeout(this.timeout);
                this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var conditional;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;

                          if (!(_this2.modalTitle == "Nuevo Jefe" || _this2.modalTitle == "Editar Jefe")) {
                            _context5.next = 7;
                            break;
                          }

                          conditional = _this2.modalTitle == "Nuevo Jefe" ? 0 : _this2.idUser;
                          _context5.next = 5;
                          return _this2.$store.dispatch("boss/validationDocumentNumberBoss", {
                            idUser: conditional,
                            documentNumber: _this2.docNumber
                          });

                        case 5:
                          _context5.next = 10;
                          break;

                        case 7:
                          if (!(_this2.modalTitle == "Nuevo Vendedor" || _this2.modalTitle == "Editar Vendedor")) {
                            _context5.next = 10;
                            break;
                          }

                          _context5.next = 10;
                          return _this2.$store.dispatch("team/validationDocumentNumberSeller", {
                            idUser: 0,
                            documentNumber: _this2.docNumber
                          });

                        case 10:
                          _this2.resultValidDocumentService = true;
                          _context5.next = 17;
                          break;

                        case 13:
                          _context5.prev = 13;
                          _context5.t0 = _context5["catch"](0);

                          if (_context5.t0 instanceof ConflictError) {
                            _this2.messageDocumentNumber = _context5.t0.message;
                          } else {
                            _this2.messageDocumentNumber = _context5.t0.message;
                          }
                          _this2.resultValidDocumentService = false;

                        case 17:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this2, [[0, 13]]);
                })), 500);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function validateDocNumber() {
        return _ref6.apply(this, arguments);
      }

      return validateDocNumber;
    }()
  }),
  computed: {
    disabled: function disabled() {
      return this.loadingSubChannels || this.loadingGroupChannels || this.sending || this.$v.$invalid || !this.resultValidEmailService || !this.resultValidDocumentService;
    },
    sellerNameErrorMessages: function sellerNameErrorMessages() {
      var errors = [];
      if (!this.$v.sellerName.$dirty) return errors;
      !this.$v.sellerName.required && errors.push("Campo obligatorio"), !this.$v.sellerName.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    sellerLastNameErrorMessages: function sellerLastNameErrorMessages() {
      var errors = [];
      if (!this.$v.sellerLastName.$dirty) return errors;
      !this.$v.sellerLastName.required && errors.push("Campo obligatorio"), !this.$v.sellerLastName.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    docNumberErrorMessages: function docNumberErrorMessages() {
      var errors = [];
      if (!this.$v.docNumber.$dirty) return errors;
      !this.$v.docNumber.minLength && errors.push("Debes ingresar m\xEDnimo " + this.maxLengthDocumentNumber + " n\xFAmeros"), !this.$v.docNumber.required && errors.push("Campo obligatorio"), !this.$v.docNumber.numeric && errors.push("Ingresa sólo números"), !this.resultValidDocumentService && errors.push(this.messageDocumentNumber);
      return errors;
    },
    emailErrorMessagesByConsult: function emailErrorMessagesByConsult() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Campo obligatorio"),
      // !this.$v.email.email && errors.push('Correo inválido'),
      !this.$v.email.noSpecialChars && errors.push("No puede ingresar caracteres espciales"), !this.$v.email.emailValidate && errors.push("Ingrese un email válido"), !this.resultValidEmailService && errors.push(this.message);
      return errors;
    }
  },
  watch: {
    conditionalIsSupervisor: function conditionalIsSupervisor(val) {
      if (val == true) {
        this.checkbox = true;
        this.conditionalShowMessageSupervisor = false;
      } else if (val == true && this.teamIsActive == true) {
        this.checkbox = true;
        this.conditionalShowMessageSupervisor = false;
        this.switchState = true;
      } else {
        this.checkbox = false;
      }
    },
    checkbox: function checkbox(val) {
      if (val == true && this.conditionalIsSupervisor == false && this.teamIsActive == true) {
        this.switchState = true;
        this.conditionalShowMessageSupervisor = true;
      } else if (val == true && this.teamIsActive == false && this.modalTitle !== "Nuevo Jefe") {
        this.switchState = false;
      } else {
        this.conditionalShowMessageSupervisor = false;
      }
    },
    switchState: function switchState(val) {
      if (val == false && this.teamIsActive == true) {
        this.checkbox = false;
        this.sending = false;
        this.conditionalShowMessageStatus = true;
      } else if (val == false && this.teamIsActive == false && this.conditionalIsSupervisor !== true) {
        this.isTeamActiveConditional = true;
        this.conditionalShowMessageStatus = false;
        this.checkbox = false;
        this.sending = false;
      } else if (val == true) {
        this.isTeamActiveConditional = false;
        this.conditionalShowMessageStatus = false;
      } else if (val == true && this.teamIsActive == true) {
        this.switchState = true;
      } else if (val == false && this.checkbox == true) {
        //this.sending = true
      } else if (val == false && this.checkbox == false) {
        this.sending = false;
      } else {
        this.sending = false;
      }
    },
    modalTitle: function modalTitle(val) {
      if (val == "Nuevo jefe") {
        this.switchState = true;
      }
    },
    channel: function channel(newVal, oldVal) {
      if (oldVal) this.$nextTick(function () {
        this.subChannel = null;
      });

      if (!newVal) return;

      this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                this.loadingSubChannels = true;
                _context7.next = 4;
                return this.consultSubChannel(newVal.value);

              case 4:
                this.subChannels = _context7.sent;
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);

                this.$controlMessage(_context7.t0);

              case 10:
                _context7.prev = 10;

                this.loadingSubChannels = false;
                return _context7.finish(10);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7, 10, 13]]);
      })));
    },
    subChannel: function subChannel(newVal, oldVal) {
      if (oldVal) this.$nextTick(function () {
        this.groupChannel = null;
      });

      if (!newVal) return;

      this.$nextTick(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                this.loadingGroupChannels = true;
                _context8.next = 4;
                return this.consultGroupChannel(newVal.value);

              case 4:
                this.groupChannels = _context8.sent;
                _context8.next = 10;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);

                this.$controlMessage(_context8.t0);

              case 10:
                _context8.prev = 10;

                this.loadingGroupChannels = false;
                return _context8.finish(10);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 7, 10, 13]]);
      })));
    }
  },
  mounted: function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return this.$store.dispatch("affiliations/form/consultChannel");

            case 3:
              this.channels = _context9.sent;
              _context9.next = 9;
              break;

            case 6:
              _context9.prev = 6;
              _context9.t0 = _context9["catch"](0);

              this.$controlMessage(_context9.t0);

            case 9:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this, [[0, 6]]);
    }));

    function mounted() {
      return _ref10.apply(this, arguments);
    }

    return mounted;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/new-seller-modal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/new-seller-modal.vue
// module chunks = 4 6 7 8 9